import * as _ from 'lodash';
import { IPatientExportability } from '@nkr/models/index';
import { GridWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import { IHeaderParams, GridReadyEvent, ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, ColDef } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { useMemo } from 'react';
import { Utility } from '@nkr/services/utility';

interface IProps {
    report: IPatientExportability[],
    onGridReady: (e: GridReadyEvent) => void
}

const PatientExportabilityReportGrid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        props.onGridReady(e);
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const reportColumns: ColDef[] = [       
        {
            colId: 'patientCenterAlias',
            field: 'patientCenterAlias',
            headerName: 'Center',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Center
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPatientExportability;
                let { patientCenterId, patientCenterAlias } = data;

                if (patientCenterId > 0) {
                    return (
                        <a target={'_blank'} href={"/center/" + patientCenterId + "/profile/edit"}>{patientCenterAlias}</a>
                    );
                } else {
                    return (
                        <span>{patientCenterAlias}</span>
                    );
                }
            },
            width: 150,
            comparator: Utility.nameComparator
        },
        {
            colId: 'patientAlias',
            field: 'patientAlias',
            headerName: 'Patient Alias',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Patient <br />Alias
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPatientExportability;
                let { patientAlias, id: patientId, patientCenterId } = data;

                if (patientId > 0 && patientCenterId > 0) {
                    return (
                        <a target={'_blank'} href={"/center/" + patientCenterId + "/recipient/" + patientId + "/profile/general"}>{patientAlias}</a>
                    )
                } else {
                    return (
                        <span>{patientAlias}</span>
                    );
                }
            },
            width: 150,
        },
        {
            colId: 'patientType',
            field: 'patientType',
            headerName: 'Patient Type',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Patient<br /> Type
                </SortableHeaderComponent>,
            width: 150,
        },
        {
            colId: 'chainNumber',
            field: 'chainNumber',
            headerName: 'Chain Number',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Chain Number
                </SortableHeaderComponent>,
            width: 120,
        },
        {
            colId: 'cluster',
            field: 'cluster',
            headerName: 'Cluster',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Cluster
                </SortableHeaderComponent>,
            width: 120,
        },
        {
            colId: 'position',
            field: 'position',
            headerName: 'Position',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Position
                </SortableHeaderComponent>,
             width: 120,
        },
        {
            colId: 'patientStatus',
            field: 'patientStatus',
            headerName: 'Status',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Status
                </SortableHeaderComponent>,
            width: 150,
        }
    ];

    const columnDefs = useMemo(() => reportColumns, []);
    const rowData = useMemo(() => props.report, [props.report]);

    return (
        <GridWrapper id='grid-wrapper' className='ag-theme-bootstrap' style={{ height: '77vh' }}>
            <AgGridReact
                defaultColDef={{
                    cellClass: 'center-list-cell',
                    headerClass: 'center-list-header',
                    sortable: true,
                    resizable: true
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={62}
                noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                suppressCellSelection={true}
                enableCellTextSelection={true}
                enableRangeSelection={true}
            />
        </GridWrapper>
    );
}

export default PatientExportabilityReportGrid;